
import React from "react";
import { sanitizeHtml } from "@/utils/htmlUtils";
import { transformBlogUrls } from "@/utils/urlTransformer";

interface ServerBlogPostContentProps {
  content: string;
}

/**
 * Server-side rendering component for blog content
 * Renders content properly for both SEO and user visibility
 */
export const ServerBlogPostContent: React.FC<ServerBlogPostContentProps> = ({ content }) => {
  // Sanitize and transform the HTML content
  const processedContent = transformBlogUrls(sanitizeHtml(content || ''));
  
  // Check if we're running on the server side
  const isServer = typeof window === 'undefined';
  
  return (
    <div className="blog-content-wrapper w-full">
      {/* Main blog content - visible to both users and search engines */}
      <article 
        className="blog-content prose prose-lg dark:prose-invert mx-auto mb-8 w-full max-w-none"
        itemScope 
        itemType="https://schema.org/BlogPosting"
        data-ssr-rendered={isServer}
      >
        <div 
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: processedContent }} 
        />
      </article>
    </div>
  );
};
